import Icon from '../assets'

const ArticlesOverviewFilterPill = ({ filter: { name, type }, onClose }) => (
  <div class='articles-overview__filter-pill'>
    <div class='articles-overview__filter-pill-name'>{name}</div>
    <Icon customClass={`qa-dismiss-${type}-filter-pill`} icon='close' width='16' height='16' onClick={onClose} />
  </div>
)

export default ArticlesOverviewFilterPill
